/**
 * @file 側邊資訊卡資料類別
 * @description 定義側邊資訊卡的資料結構與轉換類別
 */

/** 側邊資訊卡原始資料介面 */
export interface AsideCardDetailData {
  postCount?: number;
  categoriesCount?: number;
}

/** 側邊資訊卡資料轉換類別 */
export class GetAsideCardDetailClass {
  postCount: number;
  categoriesCount: number;

  constructor(data: AsideCardDetailData) {
    this.postCount = data.postCount ?? 0;
    this.categoriesCount = data.categoriesCount ?? 0;
  }
}

export { GetAsideCardDetailClass as default };
